import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const InputButton = ({ children }) => {
  const element = React.Children.only(children)

  return React.cloneElement(element, {
    className: classnames(
      'ln-c-input-group__button',
      element.props && element.props.className,
    ),
  })
}

InputButton.propTypes = {
  children: PropTypes.node,
}

InputButton.defaultProps = {
  children: undefined,
}

InputButton.displayName = 'InputButton'

export default InputButton
